<script setup>
import moment from "moment";
moment.locale("id");
</script>

<template>
  <DefaultLayout>
    <v-row class="mx-5 mt-5">
      <v-col cols="12">
        <h2 class="text-red-600 text-3xl font-inter font-bold">
          Approval CoC (Certificate of CMS Compliance)
        </h2>
        <p class="text-gray-500">
          Sini-Saja membantu mengelola & memantau perkembangan kegiatan
          kontraktor
        </p>
        <v-row class="mt-5">
          <v-col cols="6">
            <table
              class="table w-100 rounded table-borderless"
              style="overflow: hidden; font-family: 'Inter-Regular', serif"
            >
              <thead class="font-inter text-[#28293d] font-normal">
                <tr class="table-danger" style="max-height: 5vh">
                  <th class="p-2 text-nowrap text-sm" style="width: 30%">
                    Status
                  </th>
                  <th class="p-2 text-nowrap text-sm" style="width: 70%">
                    Keterangan
                  </th>
                </tr>
              </thead>
              <tbody class="text-xs">
                <tr v-for="(data, index) in listStatus" :key="index">
                  <td
                    class="align-items-center"
                    :class="{ 'table-secondary': index % 2 == 1 }"
                  >
                    <span
                      class="p-1 rounded-md text-white mx-auto"
                      :style="`background-color: ${data.color};`"
                    >
                      {{ data.name }}
                    </span>
                  </td>
                  <td :class="{ 'table-secondary': index % 2 == 1 }">
                    {{ data.description }}
                  </td>
                </tr>
              </tbody>
            </table>
          </v-col>
          <v-col cols="12" class="bg-white rounded-lg p-3 shadow-md">
            <div class="w-1/2 flex gap-3 items-center">
              <v-text-field
                variant="outlined"
                density="compact"
                color="red"
                hide-details
                clearable
                v-model="formValues.kontraktorName"
                v-on:keyup.enter="cariKontraktor"
                prepend-inner-icon="mdi-magnify"
                placeholder="Masukkan Nama Kontraktor"
              ></v-text-field>
              <v-btn
                class="bg-red-600 text-white capitalize"
                @click="refreshPage()"
              >
                Refresh Filter
              </v-btn>
            </div>
          </v-col>
          <div class="mt-8 rounded-lg shadow-md overflow-x-auto w-full">
            <v-data-table-server
              v-model:items-per-page="dataTable.pagination.itemsPerPage"
              :items-per-page-options="[5, 10, 25, 50, 100]"
              :headers="dataTable.headers"
              :items="dataTable.items"
              :items-length="dataTable.pagination.totalItems"
              @update:options="fetchData"
            >
              <template v-slot:item="{ item, index }">
                <tr
                  class="border-b border-gray-950 h-16"
                  :class="{ 'bg-gray-50': index % 2 !== 0 }"
                >
                  <td>{{ getIndex(index) }}</td>
                  <td>{{ item.namaKontraktor }}</td>
                  <td>
                    {{ moment(item.tanggalPengajuan).format("DD/MMM/YYYY") }}
                  </td>
                  <td>{{ item.namaPjo }}</td>
                  <td>
                    <div
                      v-if="
                        listStatus.some((data) => data.status == item.status)
                      "
                    >
                      <span
                        v-for="data in listStatus.filter(
                          (data) => data.status == item.status,
                        )"
                        :key="data.id"
                        class="badge"
                        style="color: #f2f0f0"
                        :style="{ 'background-color': data.color }"
                      >
                        <font-awesome-icon
                          icon="fa-solid fa-circle"
                          style="
                            font-size: 0.5em;
                            margin-bottom: 0.25em;
                            color: #f2f0f0;
                          "
                        />
                        {{ data.name }}
                      </span>
                    </div>
                  </td>
                  <td
                    class="text-center flex justify-between items-center border-b-0 w-full"
                  >
                    <a
                      class="text-red-700 font-bold cursor-pointer"
                      data-toggle="tooltip"
                      data-placement="bottom"
                      title="Lihat Dokumen"
                      style="text-decoration: none"
                      @click="lihatDokumen(item.idSio, item.kontraktorId)"
                    >
                      <img
                        src="../../assets/icons/lihat_dokumen_sio.png"
                        alt=""
                        class="w-5 h-auto"
                      />
                    </a>
                    <a
                      v-if="userData.role.includes('ADMIN')"
                      class="text-red-600 font-bold cursor-pointer"
                      @click="toggleTableDetailRow(index, item.idPenjadwalan)"
                      style="text-decoration: none"
                    >
                      <font-awesome-icon
                        icon="fa-solid fa-calendar-days"
                        data-toggle="tooltip"
                        data-placement="bottom"
                        title="Lihat Penjadwalan"
                        class="w-3 h-auto"
                      />
                      <font-awesome-icon
                        :icon="
                          tableDetailOpen.includes(index)
                            ? 'fa-solid fa-angle-up'
                            : 'fa-solid fa-angle-down'
                        "
                        data-toggle="tooltip"
                        data-placement="bottom"
                        title="Lihat Penjadwalan"
                      />
                    </a>
                    <a
                      class="font-bold"
                      :class="{
                        'text-red-600 cursor-pointer':
                          item.schedule != null && item.status >= 2,
                        'text-slate-400 opacity-50 cursor-not-allowed':
                          item.schedule == null,
                      }"
                      data-toggle="tooltip"
                      data-placement="bottom"
                      title="Isi Penilaian"
                      style="text-decoration: none"
                      @click="
                        item.schedule != null && item.status >= 2
                          ? penilaianPresentasi(
                              item.idSio,
                              item.kontraktorId,
                              item.idPenjadwalan,
                            )
                          : ''
                      "
                      ><img
                        src="../../assets/icons/isi_penilaian_sio.png"
                        alt=""
                        class="w-4 h-auto"
                    /></a>
                    <a
                      class="font-bold font-inter"
                      :class="{
                        'text-red-600 cursor-pointer': [3, 5, 6, 7, 8].includes(
                          item.status,
                        ),
                        'text-slate-400 opacity-50 cursor-not-allowed': ![
                          3, 5, 6, 7, 8,
                        ].includes(item.status),
                      }"
                      data-toggle="tooltip"
                      data-placement="bottom"
                      @click="
                        [3, 5, 6, 7, 8].includes(item.status)
                          ? toNC(item.kontraktorId, item.idPenjadwalan)
                          : ''
                      "
                      title="NC"
                      ><img
                        src="../../assets/icons/nc_sio.png"
                        alt=""
                        class="w-4 h-auto"
                    /></a>
                    <a
                      v-if="userData.role.length > 0"
                      class="font-bold pointer"
                      :class="{
                        'text-red-600 cursor-pointer': [3, 5, 7, 8].includes(
                          item.status,
                        ),
                        'text-slate-400 opacity-50 cursor-not-allowed': ![
                          3, 5, 7, 8,
                        ].includes(item.status),
                      }"
                      data-toggle="tooltip"
                      data-placement="bottom"
                      title="Surat Pengesahan PJO"
                      style="text-decoration: none"
                      @click="
                        [3, 5, 7, 8].includes(item.status)
                          ? lihatSuratPengesahan(item.idSio, item.kontraktorId)
                          : ''
                      "
                      ><img
                        src="../../assets/icons/surat_pengesahan_pjo_sio.png"
                        alt=""
                        class="w-6 h-auto"
                    /></a>
                    <a
                      v-if="userData.role.length > 0"
                      class="font-bold pointer"
                      :class="{
                        'text-red-600 cursor-pointer': [8, 7, 3].includes(
                          item.status,
                        ),
                        'text-slate-400 opacity-50 cursor-not-allowed': ![
                          8, 7, 3,
                        ].includes(item.status),
                      }"
                      @click="
                        [8, 7, 3].includes(item.status)
                          ? lihatDokumenSIO(item.idSio, item.kontraktorId)
                          : ''
                      "
                      data-toggle="tooltip"
                      data-placement="bottom"
                      title="Penerbitan CoC"
                      ><img
                        src="../../assets/icons/penerbitan_sio.png"
                        alt=""
                        class="w-5 h-auto"
                    /></a>
                    <a
                      v-if="role === levelEnum.ADMIN"
                      class="font-bold text-red-700"
                      data-toggle="tooltip"
                      data-placement="bottom"
                      title="Batalkan Pengajuan"
                      style="text-decoration: none"
                      @click="
                        item.status == 1 ? hapusPengajuan(item.idSio) : ''
                      "
                      :class="
                        item.status == 1
                          ? 'cursor-pointer'
                          : 'cursor-not-allowed opacity-50'
                      "
                    >
                      <font-awesome-icon icon="fa-solid fa-trash" style="" />
                    </a>
                  </td>
                </tr>
                <tr v-if="tableDetailOpen.includes(index)">
                  <td colspan="6">
                    <div class="shadow-sm p-3 mb-1 bg-body rounded" style="">
                      <div class="row mb-4">
                        <div class="col-md-6">
                          <strong style="font-size: 16px">
                            Penjadwalan
                            <!-- {{ dataSio[index].namaKontraktor }} -->
                          </strong>
                        </div>

                        <div class="col-md-6 justify-end items-center flex">
                          <div
                            class="text-red-700 font-bold mr-4 cursor-pointer flex items-center gap-2"
                            data-bs-toggle="modal"
                            data-bs-target="#modalHistory"
                            @click="
                              lihatHistory(
                                index,
                                dataJadwal[index].idPenjadwalan,
                              )
                            "
                            v-if="
                              dataJadwal[index] != null &&
                              userData.role.length > 0
                            "
                          >
                            <!-- <font-awesome-icon icon="fa-solid fa-file-circle-exclamation" />  -->
                            <img
                              src="../../assets/images/search.png"
                              alt=""
                              class="w-5"
                            />
                            <span>Lihat History</span>
                          </div>

                          <v-btn
                            @click="
                              penjadwalanPresentasi(
                                dataSio[index].idSio,
                                dataSio[index].kontraktorId,
                              )
                            "
                            v-if="dataJadwal[index] == null"
                            :disabled="item.status != 2"
                            color="red"
                            class="capitalize text-white"
                          >
                            Tambah Penjadwalan
                          </v-btn>
                          <v-btn
                            type="button"
                            @click="
                              penjadwalanPresentasi(
                                dataSio[index].idSio,
                                dataSio[index].kontraktorId,
                                dataJadwal[index].idPenjadwalan,
                              )
                            "
                            color="red"
                            class="capitalize text-white"
                            v-if="
                              dataJadwal[index] != null &&
                              userData.role.length > 0
                            "
                            :disabled="
                              moment(dataJadwal[index].tanggal).format(
                                'YYYY-MM-DD',
                              ) < moment(new Date()).format('YYYY-MM-DD')
                            "
                          >
                            Edit Penjadwalan
                          </v-btn>
                        </div>
                      </div>

                      <template v-if="dataJadwal[index] != null">
                        <div class="row">
                          <div class="col-md-6">
                            <strong>Tanggal Presentasi</strong>
                            <p>
                              {{
                                dataJadwal[index].tanggal != null
                                  ? moment(dataJadwal[index].tanggal).format(
                                      "LL",
                                    )
                                  : "-"
                              }}
                            </p>
                          </div>
                          <div class="col-md-6">
                            <strong>Lokasi Presentasi</strong>
                            <p>{{ dataJadwal[index].lokasi }}</p>
                          </div>
                        </div>

                        <div class="row">
                          <template
                            v-for="(dp, idx) in dataJadwal[index].dataPenilaian"
                            :key="idx"
                          >
                            <div class="col-md-6">
                              <strong>Kustodian</strong>
                              <p>
                                {{
                                  dp.namaKustodian == null ||
                                  dp.namaKustodian == ""
                                    ? "-"
                                    : dp.namaKustodian
                                }}
                              </p>
                            </div>
                            <div class="col-md-6">
                              <strong>Aspek</strong>
                              <p>
                                {{
                                  dp.aspekPenilaian == null ||
                                  dp.aspekPenilaian == ""
                                    ? "-"
                                    : dp.aspekPenilaian
                                }}
                              </p>
                            </div>

                            <hr
                              v-if="idx < dp.length - 1"
                              style="
                                height: 10px;
                                border: 0;
                                box-shadow: 0 -15px 5px -10px #333 inset;
                              "
                            />
                          </template>
                        </div>
                      </template>

                      <template v-else>
                        <div class="row">
                          <div class="col-md-12" style="text-align: center">
                            <img
                              src="../../assets/images/search.png"
                              alt=""
                              :style="{
                                // width: '20px',
                                marginBottom: '15px',
                              }"
                            />
                            <br />
                            <strong class="text-red-700 font-semibold text-sm">
                              Belum ada Penjadwalan Presentasi
                            </strong>
                          </div>
                        </div>
                      </template>
                    </div>
                    <div v-if="isLoadingJadwal[index]" class="loading-overlay">
                      <!-- &lt;!&ndash; You can customize the loading content here (e.g., a spinner) &ndash;&gt; -->
                      <div>
                        <img
                          src="@/assets/icons/Spinner-1s-200px.svg"
                          style="height: 10rem"
                          alt=""
                        />
                      </div>
                    </div>
                  </td>
                </tr>
              </template>
            </v-data-table-server>
          </div>
        </v-row>
      </v-col>
    </v-row>
  </DefaultLayout>
  <!--  Tambah Penjadwalan -->
  <div
    class="modal fade"
    id="AddPenjadwalan"
    tabindex="-1"
    aria-labelledby="AddPenjadwalan"
    aria-hidden="true"
  >
    <div class="modal-dialog-centered">
      <div
        class="modal-dialog modal-content card shadow-sm rounded-3 border-0"
        style="height: 486px; width: 500px"
      >
        <div
          class="modal-content rounded-bottom-5 rounded-top-3 border-0"
          style="height: 208px; width: 500px; background: rgba(181, 26, 26, 1)"
        >
          <div class="d-flex justify-content-end w-100 p-3">
            <button
              type="button"
              id="btnClose"
              class="btn"
              data-bs-dismiss="modal"
              aria-label="Close"
            >
              <img
                src="../../assets/icons/close_whaite.png"
                alt="icon"
                width="24"
                height="24"
              />
            </button>
          </div>
          <div
            class="px-5 py-4 text-white"
            style="font-family: Inter, sans-serif"
          >
            <h4 class="fw-bold">Penjadwalan Presentasi</h4>
            <small>Pilih Tanggal Presentasi dan Kustodian</small>
          </div>
        </div>
        <div class="modal-body">
          <div class="px-4">
            <div class="form-group mt-2">
              <label for="TglPresentasi" class="form-label fs-8"
                ><small>Tanggal Presentasi</small></label
              >
              <input type="date" class="form-control fs-9" id="TglPresentasi" />
            </div>
            <div class="form-group mt-3 mb-5">
              <label for="Kustodian" class="form-label fs-8"
                ><small>Tanggal Presentasi</small></label
              >
              <input
                type="text"
                class="form-control fs-9"
                id="Kustodian"
                placeholder="Masukkan Nama Kustodian"
              />
            </div>

            <div class="d-flex justify-content-center mt-4">
              <button
                type="button"
                class="btn btn-sm bg-secondary w-75 text-white"
              >
                Simpan
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!--  End Tambah Penjadwalan -->

  <!--  Penjadwalan Ulang-->
  <div
    class="modal fade"
    id="AddPenjadwalanUlang"
    tabindex="-1"
    aria-labelledby="AddPenjadwalanUlang"
    aria-hidden="true"
  >
    <div class="modal-dialog-centered">
      <div
        class="modal-dialog modal-content card shadow-sm rounded-3 border-0"
        style="height: 486px; width: 500px"
      >
        <div
          class="modal-content rounded-bottom-5 rounded-top-3 border-0"
          style="height: 208px; width: 500px; background: rgba(181, 26, 26, 1)"
        >
          <div class="d-flex justify-content-end w-100 p-3">
            <button
              type="button"
              id="btnClose"
              class="btn"
              data-bs-dismiss="modal"
              aria-label="Close"
            >
              <img
                src="../../assets/icons/close_whaite.png"
                alt="icon"
                width="24"
                height="24"
              />
            </button>
          </div>
          <div
            class="px-5 py-4 text-white"
            style="font-family: Inter, sans-serif"
          >
            <h4 class="fw-bold">Penjadwalan Presentasi</h4>
            <small>Pilih Tanggal Presentasi dan Kustodian</small>
          </div>
        </div>
        <div class="modal-body">
          <div class="px-4">
            <div class="form-group mt-2">
              <label for="TglPresentasi" class="form-label fs-8"
                ><small>Tanggal Presentasi</small></label
              >
              <input type="date" class="form-control fs-9" id="TglPresentasi" />
            </div>
            <div class="form-group mt-3 mb-5">
              <label for="Kustodian" class="form-label fs-8"
                ><small>Tanggal Presentasi</small></label
              >
              <input
                type="text"
                class="form-control fs-9"
                id="Kustodian"
                placeholder="Masukkan Nama Kustodian"
              />
            </div>

            <div class="d-flex justify-content-center mt-4">
              <button
                type="button"
                class="btn btn-sm bg-danger w-75 text-white"
              >
                Simpan
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!--  End Penjadwalan Ulang-->

  <div
    ref="modalTerbit"
    class="modal fade"
    id="exampleModal"
    tabindex="-1"
    aria-labelledby="exampleModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div
          class="modal-header"
          style="background: rgba(181, 26, 26, 1); color: #ffffff"
        >
          <div class="col-md-11">
            <h5 class="modal-title">Apakah anda yakin akan menerbitkan CoC?</h5>
            <p class="fs-8">
              Dengan melanjutkan, Anda setuju bahwa data yang Anda berikan
              adalah akurat dan sah.
            </p>
          </div>
          <div class="col-md-1">
            <div class="d-flex justify-content align-items-start">
              <button
                ref="closeModal"
                type="button"
                id="btnClose"
                style="background: none; border: 0"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <font-awesome-icon
                  icon="fa-solid fa-x"
                  style="color: #ffffff"
                />
              </button>
            </div>
          </div>
        </div>
        <div class="modal-body" style="font-family: 'Inter-Regular'">
          <button
            class="btn btn_cari w-100 fs-8 fw-bold mb-2"
            @click="terbitSIO()"
          >
            Ya, Terbitkan
          </button>
          <button
            class="btn btn_lihat_dokumen w-100 fs-8 fw-bold"
            @click="lihatDokumenSIO(clicked.idSio, clicked.kontraktorId)"
          >
            Lihat Dokumen
          </button>
        </div>
      </div>
    </div>
  </div>

  <div
    class="modal fade"
    id="modalHistory"
    ref="modalHistory"
    tabindex="-1"
    aria-labelledby="modalHistoryLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-scrollable modal-xl">
      <div class="modal-content">
        <div class="modal-header flex justify-between">
          <h5 class="modal-title">History Penjadwalan</h5>
          <div class="d-flex justify-content-end">
            <button
              ref="closeModalHistory"
              type="button"
              id="btnClose"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
              @click="closeHistory"
            ></button>
          </div>
        </div>
        <div class="modal-body" style="font-family: 'Inter-Regular'">
          <!-- <p>Modal body text goes here.</p> -->
          <div class="container-flud p-3">
            <template v-if="viewDataHistory == null && viewDataJadwal != null">
              <div class="row">
                <div class="col-md-12">
                  <strong>Tanggal Presentasi</strong>
                  <p>
                    {{
                      dataJadwal[viewDataJadwal].tanggal != null
                        ? moment(dataJadwal[viewDataJadwal].tanggal).format(
                            "LL",
                          )
                        : "-"
                    }}
                  </p>
                </div>
              </div>

              <div class="row">
                <template
                  v-for="(dp, idx) in dataJadwal[viewDataJadwal].dataPenilaian"
                  :key="idx"
                >
                  <div
                    class="row border-t border-b pt-2"
                    v-if="
                      dp.idAspekPenilaian != 16 &&
                      dp.idAspekPenilaian != 17 &&
                      dp.idAspekPenilaian != 18 &&
                      dp.idAspekPenilaian != 19 &&
                      dp.idAspekPenilaian != 20 &&
                      dp.idAspekPenilaian != 21
                    "
                  >
                    <div class="col-md-6">
                      <strong>Kustodian</strong>
                      <p>
                        {{
                          dp.namaKustodian == null || dp.namaKustodian == ""
                            ? "-"
                            : dp.namaKustodian
                        }}
                      </p>
                    </div>
                    <div class="col-md-6">
                      <strong>Aspek</strong>
                      <p>
                        {{
                          dp.aspekPenilaian == null || dp.aspekPenilaian == ""
                            ? "-"
                            : dp.aspekPenilaian
                        }}
                      </p>
                    </div>
                  </div>
                  <hr
                    v-if="idx < dp.length - 1"
                    style="
                      height: 10px;
                      border: 0;
                      box-shadow: 0 -15px 5px -10px #333 inset;
                    "
                  />
                </template>
              </div>
            </template>
            <template v-else-if="viewDataHistory != null">
              <div v-for="(dh, idx) in dataHistory[viewDataHistory]" :key="idx">
                <div
                  class="row mb-2"
                  :class="{
                    'border-b-4': idx < dataHistory[viewDataHistory].length - 1,
                  }"
                >
                  <div class="row">
                    <div class="col-md-12">
                      <strong>Tanggal Presentasi</strong>
                      <p>
                        {{
                          dh.schedule != null
                            ? moment(dh.schedule).format("LL")
                            : "-"
                        }}
                      </p>
                    </div>
                  </div>

                  <div class="row">
                    <template v-for="(dpn, idy) in dh.dataPenilaian" :key="idy">
                      <div
                        class="row border-top border-t border-b pt-2"
                        v-if="
                          dpn.idAspekPenilaian != 16 &&
                          dpn.idAspekPenilaian != 17 &&
                          dpn.idAspekPenilaian != 18 &&
                          dpn.idAspekPenilaian != 19 &&
                          dpn.idAspekPenilaian != 20 &&
                          dpn.idAspekPenilaian != 21
                        "
                      >
                        <div class="col-md-6">
                          <strong>Kustodian</strong>
                          <p>
                            {{
                              dpn.namaKustodian == null ||
                              dpn.namaKustodian == ""
                                ? "-"
                                : dpn.namaKustodian
                            }}
                          </p>
                        </div>
                        <div class="col-md-6">
                          <strong>Aspek</strong>
                          <p>
                            {{
                              dpn.aspekPenilaian == null ||
                              dpn.aspekPenilaian == ""
                                ? "-"
                                : dpn.aspekPenilaian
                            }}
                          </p>
                        </div>
                      </div>
                      <!-- <hr v-if="idy < dpn.length - 1" style="height: 10px; border: 0; box-shadow: 0 -15px 5px -10px #333 inset;"/> -->
                    </template>
                  </div>
                  <!-- <hr v-if="idx < dataHistory[viewDataHistory].length - 1" class="w-100" style="height: 5px; border: 0; box-shadow: 0 -15px 5px -10px #333 inset;"/> -->
                </div>
              </div>
            </template>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.btn_lihat_dokumen {
  background: #ffffff !important;
  color: #dd3737 !important;
}
</style>

<script>
// import SidebarComponent from "@/components/SideBar.vue";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

import GlobalDataMixin from "../../GlobalDataMixin";
import {
  API_BASE_URL,
  CMS_SIO_LIST,
  CMS_SET_SIOID,
  CMS_GET_JADWALNILAI,
  CMS_GET_JADWALHISTORY,
  CMS_GET_SIOCUSTODIAN,
  CMS_SET_SIO_INACTIVE,
} from "../../constants.js";
import axios from "axios";
import Swal from "sweetalert2";
import MasterDataStatus from "@/data/status.json";
import DefaultLayout from "@/layouts/DefaultLayout.vue";
import {
  CreateDataTableObject,
  SetDataTableResponse,
} from "@/utilities/DataTableHelpers";
import util from "@/assets/js/util";
import { levelEnum } from "@/utilities/enum";

const url_set_sioid = API_BASE_URL + CMS_SET_SIOID;
const url_list_sio = API_BASE_URL + CMS_SIO_LIST;
const url_get_jadwal = API_BASE_URL + CMS_GET_JADWALNILAI;
const url_get_history = API_BASE_URL + CMS_GET_JADWALHISTORY;
const url_get_siocustodian = API_BASE_URL + CMS_GET_SIOCUSTODIAN;
const url_inactive = API_BASE_URL + CMS_SET_SIO_INACTIVE;

export default {
  mixins: [GlobalDataMixin],
  name: "ApprovalSioPage",
  components: {
    FontAwesomeIcon,
    DefaultLayout,
  },
  data() {
    return {
      dataTable: CreateDataTableObject([
        { title: "No.", align: "start", sortable: false, width: "5%" },
        {
          title: "Nama Kontraktor",
          align: "start",
          sortable: false,
          width: "25%",
        },
        {
          title: "Tanggal Pengajuan",
          align: "start",
          sortable: false,
          width: "15%",
        },
        { title: "Nama PJO", align: "start", sortable: false, width: "10%" },
        { title: "Status", align: "start", sortable: false, width: "15%" },
        { title: "Action", align: "center", sortable: false, width: "30%" },
      ]),
      // detailsOpen: [],
      isLoadingJadwal: [],
      dataJadwal: [],
      dataHistory: [],
      viewDataHistory: null,
      viewDataJadwal: null,
      dataSio: [],
      currentPage: 1,
      perPage: 5,
      totalData: 0,
      formValues: {
        keyword: "",
        perPage: 5,
        email: "",
        kontraktorId: "",
        NamaKontraktor: "",
        status: [1, 2],
        kontraktorName: null,
      },
      clicked: {
        idSio: null,
        kontraktorId: null,
      },
      tableDetailOpen: [],
      listStatus: [],
      role: null,
      levelEnum,
      filtersInitialized: false,
    };
  },
  created() {
    this.role = this.resolveUserRole(this.userData.role);

    const canAccess = [
      levelEnum.ADMIN,
      levelEnum.OHS,
      levelEnum.REPORTER,
      levelEnum.ENVIRONMENT,
      levelEnum.IMPROVEMENT,
      levelEnum.ISAFE,
    ].includes(this.role);

    if (!canAccess) {
      util.showError("Anda tidak memiliki akses ke halaman ini");

      this.$router.push("/dashboard");
    }

    this.listStatus = MasterDataStatus.filter((item) => item.type.includes(1));
    this.initFiltersFromQuery();
  },
  mounted() {
    this.filtersInitialized = true;
  },
  activated() {
    if (this.filtersInitialized) {
      this.initFiltersFromQuery();
      this.fetchData();
    }
  },
  methods: {
    initFiltersFromQuery() {
      const q = this.$route.query;
      this.formValues.kontraktorName = q.kontraktorName ?? "";
      if (q.page !== undefined && q.page !== "") {
        this.currentPage = Number(q.page);
        this.dataTable.pagination.page = Number(q.page);
      }
      if (q.perPage !== undefined && q.perPage !== "") {
        this.formValues.perPage = Number(q.perPage);
        this.dataTable.pagination.itemsPerPage = Number(q.perPage);
      }
    },
    syncFiltersToUrl() {
      this.$router.replace({
        query: {
          kontraktorName: this.formValues.kontraktorName || undefined,
          page: this.currentPage > 1 ? this.currentPage : undefined,
          perPage: this.formValues.perPage !== 5 ? this.formValues.perPage : undefined,
        },
      }).catch(() => {});
    },
    buildSioQuery() {
      return {
        kontraktorName: this.formValues.kontraktorName || undefined,
        page: this.currentPage > 1 ? this.currentPage : undefined,
        perPage: this.formValues.perPage !== 5 ? this.formValues.perPage : undefined,
      };
    },
    fetchData({ page, itemsPerPage } = {}) {
      if (page) {
        this.currentPage = page;
      }
      if (itemsPerPage) {
        this.formValues.perPage = itemsPerPage;
      }
      this.syncFiltersToUrl();
      if (
        [
          levelEnum.OHS,
          levelEnum.REPORTER,
          levelEnum.ENVIRONMENT,
          levelEnum.IMPROVEMENT,
          levelEnum.ISAFE,
        ].includes(this.role)
      ) {
        this.getListSioCustodian();
      } else {
        this.getListSio();
      }
    },
    resetPaginasi() {
      this.dataSio = [];
      this.tableDetailOpen = [];
      this.formValues.perPage = 5;
      this.currentPage = 1;
      this.totalData = 0;
    },
    cariKontraktor() {
      this.tableDetailOpen = [];
      this.resetPaginasi();
      this.syncFiltersToUrl();
      if (
        [
          levelEnum.OHS,
          levelEnum.REPORTER,
          levelEnum.ENVIRONMENT,
          levelEnum.IMPROVEMENT,
          levelEnum.ISAFE,
        ].includes(this.role)
      ) {
        this.getListSioCustodian();
      } else {
        this.getListSio();
      }
    },
    getIndex(index) {
      return index + (this.currentPage - 1) * this.perPage + 1;
    },
    getListSio() {
      let bodyJsonProfile = {
        page: this.currentPage,
        perPage: this.formValues.perPage,
        nama: this.formValues.kontraktorName,
        type: 1,
      };
      // const user = localStorage.getItem("user_cms");
      // const tokens = JSON.parse(user)
      axios
        .post(url_list_sio, bodyJsonProfile, {
          headers: {
            role: "isafe",
            Authorization: "Bearer " + this.userData.token,
            accept: "application/json",
          },
        })
        .then((response) => {
          let result = {};
          result.data = response.data.data;
          result.total_data = response.data.total;
          result.total_per_page = this.formValues.perPage;
          result.current_page = this.currentPage;
          this.dataTable = SetDataTableResponse(this.dataTable, result);

          this.dataSio = response.data.data;
          this.totalData = response.data.total;
          let arrLoadJadwal = [];
          let arrDataJadwal = [];
          let arrDataHistory = [];
          for (let x = 0; x < response.data.data.length; x++) {
            arrLoadJadwal.push(false);
            arrDataJadwal.push(null);
            arrDataHistory.push(null);
          }
          this.isLoadingJadwal = arrLoadJadwal;
          this.dataJadwal = arrDataJadwal;
          this.dataHistory = arrDataHistory;
        })
        .catch((error) => {
          console.log("error setSioID : ", error);
          alert("error setSioID");
        })
        .then(() => {});
    },
    getListSioCustodian() {
      let bodyJsonProfile = {
        idKustodian: this.userData.id,
        page: this.currentPage,
        perPage: this.formValues.perPage,
        namaKontraktor: this.formValues.kontraktorName,
        type: 1,
      };

      axios
        .post(url_get_siocustodian, bodyJsonProfile, {
          headers: {
            role: "isafe",
            Authorization: "Bearer " + this.userData.token,
            accept: "application/json",
          },
        })
        .then((response) => {
          let result = {};
          result.data = response.data.data;
          result.total_data = response.data.total;
          result.total_per_page = this.formValues.perPage;
          result.current_page = this.currentPage;
          this.dataTable = SetDataTableResponse(this.dataTable, result);

          this.dataSio = response.data.data;
          // this.totalData = response.data.total;
          this.totalData = response.data.data.length;
          let arrLoadJadwal = [];
          let arrDataJadwal = [];
          let arrDataHistory = [];
          for (
            let x = (this.currentPage - 1) * this.perPage;
            x < response.data.data.length;
            x++
          ) {
            arrLoadJadwal.push(false);
            arrDataJadwal.push(null);
            arrDataHistory.push(null);
          }
          this.isLoadingJadwal = arrLoadJadwal;
          this.dataJadwal = arrDataJadwal;
          this.dataHistory = arrDataHistory;
        })
        .catch((error) => {
          console.log("error setSioID : ", error);
          alert("error setSioID");
        });
    },
    preventSubmit() {
      console.log("prevent submit");
    },
    refreshPage() {
      this.formValues.kontraktorName = "";
      this.formValues.selectedStatus = [];
      this.formValues.selectedKategori = [];
      this.currentPage = 1;
      this.dataTable.pagination.page = 1;
      this.syncFiltersToUrl();
      this.fetchData();
    },
    lihatDokumen(idsio, kontraktorId) {
      this.$refs.closeModal.click();
      this.$router.push({
        path: "/dokumenpersyaratanpengajuanpjo/" + idsio + "/" + kontraktorId,
        query: this.buildSioQuery(),
      });
    },
    lihatDokumenSIO(idsio, kontraktorId) {
      this.$refs.closeModal.click();
      this.$router.push({
        path: "/lihatDokumenSIO/" + idsio + "/" + kontraktorId,
        query: this.buildSioQuery(),
      });
    },
    penjadwalanPresentasi(idsio, kontraktorId, idpenjadwalan) {
      this.$refs.closeModal.click();
      console.log("idpenjadwalan:", idpenjadwalan);
      if (idpenjadwalan !== null && idpenjadwalan !== undefined) {
        this.$router.push({
          path: `/approval-sio/penjadwalan-presentasi/${idsio}/${kontraktorId}/${idpenjadwalan}`,
          query: {
            type: "new-coc",
            ...this.buildSioQuery(),
          },
        });
      } else {
        this.$router.push({
          path: `/approval-sio/penjadwalan-presentasi/${idsio}/${kontraktorId}`,
          query: {
            type: "new-coc",
            ...this.buildSioQuery(),
          },
        });
      }
    },
    penilaianPresentasi(idsio, kontraktorId, idpenjadwalan) {
      this.$refs.closeModal.click();
      this.$router.push({
        path:
          "/approval-sio/penilaian-presentasi/" +
          idsio +
          "/" +
          kontraktorId +
          "/" +
          idpenjadwalan,
        query: this.buildSioQuery(),
      });
    },
    showModal(ids, kid) {
      this.clicked.idSio = ids;
      this.clicked.kontraktorId = kid;
    },
    terbitSIO() {
      this.isLoading = true;
      let bodyJson = {
        kontraktorId: this.clicked.kontraktorId,
        action: "publish-sio",
        id: this.clicked.idSio,
      };
      axios
        .post(url_set_sioid, bodyJson, {
          headers: {
            role: "isafe",
            Authorization: "Bearer " + this.userData.token,
            accept: "application/json",
          },
        })
        .then((response) => {
          console.log("response terbitSIO : ", response);
          this.alertSuksesTerbitSio();
          this.isLoading = false;
        })
        .catch((error) => {
          this.isLoading = false;
          console.log("error terbitSIO : ", error);
          util.showError(error.response.data.status.message);
        })
        .then(() => {});
    },
    alertSuksesTerbitSio() {
      Swal.fire({
        title: "Proses Pengajuan CoC",
        text: "CoC Berhasil Diterbitkan!",
        icon: "success",
        showConfirmButton: false,
        timer: 2000,
        showClass: {
          popup: "animate__animated animate__fadeInDown",
        },
        hideClass: {
          popup: "animate__animated animate__fadeOutUp",
        },
      }).then(() => {
        this.$refs.closeModal.click();
        // this.$router.back()
        this.$router.go();
      });
    },
    toggleTableDetailRow(index, idpenjadwalan) {
      console.log("toggleTableDetailRow called with index:", index); // Debug log
      console.log("toggle idpenjadwalan:", idpenjadwalan);
      if (idpenjadwalan != null) {
        if (this.dataJadwal[index] == null) {
          this.isLoadingJadwal[index] = true;
          axios
            .get(url_get_jadwal + idpenjadwalan, {
              headers: {
                role: "isafe",
                Authorization: "Bearer " + this.userData.token,
                accept: "application/json",
              },
            })
            .then((response) => {
              console.log("response getJadwalSio :  ", response);
              let dtj = response.data;
              if (dtj.idSio != null) {
                let arr_dp = [];
                for (let x = 0; x < dtj.dataPenilaian.length; x++) {
                  let dp = dtj.dataPenilaian[x];
                  console.log("id:", dp.idAspekPenilaian);

                  if (
                    dp.idAspekPenilaian != 16 &&
                    dp.idAspekPenilaian != 17 &&
                    dp.idAspekPenilaian != 18 &&
                    dp.idAspekPenilaian != 19 &&
                    dp.idAspekPenilaian != 20 &&
                    dp.idAspekPenilaian != 21
                  ) {
                    arr_dp.push(dp);
                  }
                }

                this.dataJadwal[index] = {
                  tanggal: dtj.schedule,
                  idSio: dtj.idSio,
                  idPenjadwalan: dtj.idPenjadwalan,
                  dataPenilaian: arr_dp,
                  lokasi: dtj.lokasi,
                };
              }

              this.isLoadingJadwal[index] = false;
              console.log("dataJadwal : ", this.dataJadwal);
            })
            .catch((error) => {
              this.isLoadingJadwal[index] = false;
              alert("Error Fetch Data getJadwalSio : " + error);
              console.error("Error fetching data getJadwalSio :", error);
            });
        }
      }

      const detailIndex = this.tableDetailOpen.indexOf(index);
      if (detailIndex > -1) {
        this.tableDetailOpen.splice(detailIndex, 1); // Remove the index if it's already open
      } else {
        this.tableDetailOpen.push(index); // Add the index if it's not open
      }
    },
    getHistory(index, idpenjadwalan) {
      this.isLoadingJadwal[index] = true;
      let bodyJson = {
        idPenjadwalan: idpenjadwalan,
      };
      if (idpenjadwalan != null) {
        axios
          .post(url_get_history, bodyJson, {
            headers: {
              role: "isafe",
              Authorization: "Bearer " + this.userData.token,
              accept: "application/json",
            },
          })
          .then((response) => {
            console.log("response getHistory : ", response);
            //console.log("jsonparse : ",JSON.parse(response.data.history));
            let resH = response.data.history;
            let arrH = [];
            for (let i = resH.length - 1; i >= 0; i--) {
              // console.log('resh-'+i+':',resH[i]);
              arrH.push(JSON.parse(resH[i]));
            }
            this.dataHistory[index] = arrH;
            // this.alertSuksesTerbitSio()
            this.isLoadingJadwal[index] = false;
            console.log("dh:", this.dataHistory[index]);
          })
          .catch((error) => {
            this.isLoading = false;
            console.log("error getHistory : ", error);
            alert("error getHistory");
          })
          .then(() => {});
      }
    },
    lihatHistory(index, idPenjadwalan) {
      if (idPenjadwalan == null) {
        // alert('History penjadwalan kosong!')
        // this.$refs.closeModalHistory.click()
        this.viewDataJadwal = index;
      } else {
        this.viewDataHistory = index;
        this.getHistory(index, idPenjadwalan);
      }
    },
    closeHistory() {
      this.viewDataHistory = null;
      this.viewDataJadwal = null;
      this.$refs.closeModalHistory.click();
    },
    toNC(kontraktorId, idPenjadawalan) {
      this.$router.push({
        path: "/nc/" + kontraktorId + "/" + idPenjadawalan,
        query: this.buildSioQuery(),
      });
    },
    lihatSuratPengesahan(idSio, kontraktorId) {
      this.$router.push({
        path: "/approval-sio/surat-pengesahan/" + idSio + "/" + kontraktorId,
        query: this.buildSioQuery(),
      });
    },
    hapusPengajuan(id) {
      Swal.fire({
        title: "Apakah Anda yakin membatalkan pengajuan coc baru?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Ya",
      }).then((result) => {
        if (result.isConfirmed) {
          this.deletePengajuan(id);
        }
      });
    },
    deletePengajuan(id) {
      let bodyJson = {
        id: id,
      };
      axios
        .get(url_inactive, {
          params: bodyJson,
          headers: {
            role: "isafe",
            Authorization: "Bearer " + this.userData.token,
            Accept: "application/json",
            "Access-Control-Allow-Origin": "*",
            "Access-Control-Allow-Methods": "GET, POST, PUT, DELETE",
            "Access-Control-Allow-Headers":
              "Content-Type, Authorization, Accept",
          },
        })
        .then(() => {
          Swal.fire({
            title: "Pengajuan CoC Dibatalkan",
            text: "Pengajuan coc baru berhasil dibatalkan !",
            icon: "success",
            showConfirmButton: false,
            timer: 2000,
            showClass: {
              popup: "animate__animated animate__fadeInDown",
            },
            hideClass: {
              popup: "animate__animated animate__fadeOutUp",
            },
          }).then(() => {
            location.reload();
          });
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
};
</script>

<style scoped>
/* :deep(table) {
  table-layout: auto !important;
  width: max-content !important;
  min-width: 100%;
} */
:deep(thead) {
  background-color: #fecaca;
}
</style>
